import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import cls from '../step7.module.scss';

const sexPlaceArr = ['unisex', 'men', 'women'];

const lvlActivePersonArr = ['any', 'begin', 'lover', 'professional'];

function OfferPrice({
  index,
  errors,
  control,
  register,
  formValues,
  setTicketForm,
}) {
  const { t } = useTranslation();

  const [sexPlace, setSexPlace] = useState([]);
  const [lvlActivePerson, setLvlActivePerson] = useState([]);

  useEffect(() => {
    const sexPlaceType = sexPlaceArr.map((el) => ({
      value: el,
      label: t(`create.step7.sex.${el}`),
    }));
    const lvlActivePersonType = lvlActivePersonArr.map((el) => ({
      value: el,
      label: t(`create.step2.element.${el}`),
    }));

    setSexPlace(sexPlaceType);
    setLvlActivePerson(lvlActivePersonType);
  }, [t]);

  const { onChange: onChangePlaces, ...placesProps } = register(
    `packages.${index}.places`,
    {
      required: t('form.validate.required'),
      min: {
        value: 1,
        message: t('form.validate.maxItem2'),
      },
    },
  );

  const { onChange: onChangePlacesOffer, ...propsPlacesOffer } = register(
    `packages.${index}.placesOfOffer`,
    {
      required: t('form.validate.required'),
      min: {
        value: 1,
        message: t('form.validate.maxItem2'),
      },
      max: {
        value:
          +formValues?.packages?.[index]?.places *
          +formValues?.packages?.[index]?.placesOfOffer,
        message: t('form.validate.maxItem2'),
      },
    },
  );

  return (
    <div className={`${cls.box_offer} ${cls.condizione}`}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel>{t('create.step7.sex.genderPlace')}</InputLabel>
            <Controller
              defaultValue={formValues?.sexGender}
              render={({ field }) => (
                <Select {...field}>
                  {sexPlace.map((el, key) => (
                    <MenuItem value={el.value || ''} button key={key}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              onClick={(e) => {
                setTicketForm({ sexGender: e.target.value });
              }}
              name="sexGender"
              control={control}
              className={cls.model}
              label={t('create.step7.sex.genderPlace')}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel>{t('create.step7.lvlSkillPerson')}</InputLabel>
            <Controller
              render={({ field }) => (
                <Select {...field}>
                  {lvlActivePerson.map((el, key) => (
                    <MenuItem value={el.value || ''} button key={key}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              defaultValue={formValues?.lvlPerson}
              name="lvlPerson"
              control={control}
              onClick={(e) => {
                setTicketForm({ lvlPerson: e.target.value });
              }}
              className={cls.model}
              label={t('create.step7.lvlSkillPerson')}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            error={!!errors?.packages?.[index]?.places}
            label={`${t('purchase.participants')} *`}
            name={`packages.${index}.places`}
            placeholder={t('create.step7.description')}
            onChange={(e) => {
              onChangePlaces(e);
              setTicketForm({
                packages: formValues?.packages.map((i, ind) =>
                  ind === index ? { ...i, places: +e.target.value } : i,
                ),
              });
            }}
            type="number"
            fullWidth
            autoComplete="off"
            variant="outlined"
            packagesProps
            {...placesProps}
            helperText={
              errors?.packages?.[index]?.places
                ? errors?.packages?.[index]?.places.message
                : ''
            }
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            error={!!errors?.packages?.[index]?.placesOfOffer}
            label={`${t('create.step7.freeOffer')} *`}
            placeholder={t('create.step7.description')}
            type="number"
            fullWidth
            onChange={(e) => {
              onChangePlacesOffer(e);
              setTicketForm({
                packages: formValues?.packages.map((i, ind) =>
                  ind === index
                    ? { ...i, placesOfOffer: Number(e.target.value) }
                    : i,
                ),
              });
            }}
            autoComplete="off"
            variant="outlined"
            {...propsPlacesOffer}
            helperText={
              errors?.packages?.[index]?.placesOfOffer
                ? errors?.packages?.[index]?.placesOfOffer?.message
                : ''
            }
          />
        </Grid>
      </Grid>
    </div>
  );
}
OfferPrice.propTypes = {
  index: PropTypes.number.isRequired,
  errors: PropTypes.shape({}),
  formValues: PropTypes.shape({}).isRequired,
  setTicketForm: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  control: PropTypes.shape({}).isRequired,
};

OfferPrice.defaultProps = {
  errors: null,
};
export default OfferPrice;
